<template>
<div id="home" class="container">
<b-overlay :show="this.expiredTrial" rounded="sm" no-center>

  <Search class="mt-2">
  </Search>

  <LoadingIndicator></LoadingIndicator>
  <ListLoader v-if="!response"
    :speed="2"
    :animate="true"
    class="loader"
   ></ListLoader>

  <SuggestedFilters></SuggestedFilters>
  <ActiveFilters></ActiveFilters>
  <Toolbar></Toolbar>
  <SemanticGraph></SemanticGraph>
  <Error></Error>
    <b-row>
        <b-col cols="4">
          <PreserveFilters></PreserveFilters>
          <FacetFields></FacetFields>
          <FacetRanges></FacetRanges>
        </b-col>
        <b-col cols="8">
            <Sorting></Sorting>
            <Spelling></Spelling>
            <div class="clearfix"></div>
            <DateHistogramSlider v-bind:facetname="'Deadlines'"></DateHistogramSlider>
            <div class="clearfix"></div>
            <ResultList></ResultList>

        </b-col>
    </b-row>

  <ResultDetail v-if="this.$route.params.id" v-bind:id="this.$route.params.id"></ResultDetail>


  <template #overlay>
    <div class="text-center">
      <b-icon icon="lock" font-scale="3" animation="cylon" class="mb-3 mt-5"></b-icon>
      <h2 id="cancel-label">Your trial account has expired. <br>Register for a <a href="https://www.sci-fund.ai/plans-and-prices" target="_blank">full membership</a> or <a href="mailto:info@sci-fund.ai?subject=sci-fund%20Account">get in touch</a>.</h2>

    </div>
  </template>

</b-overlay>

</div>

</template>

<script>
import Search from '@/components/Search'
import FacetFields from '@/components/FacetFields'
import ActiveFilters from '@/components/ActiveFilters'
import SuggestedFilters from '@/components/SuggestedFilters'
//import AutoFilters from '@/components/AutoFilters'
import SemanticGraph from '@/components/SemanticGraph'
import FacetRanges from '@/components/FacetRanges'
import ResultList from '@/components/ResultList'
import ResultDetail from '@/components/ResultDetail'
//import SpecialDateFilter from '@/components/SpecialDateFilter'
import Toolbar from '@/components/Toolbar'
import Sorting from '@/components/Sorting'
import Spelling from '@/components/Spelling'
import Error from '@/components/Error'
import LoadingIndicator from '@/components/LoadingIndicator'
import { ListLoader } from 'vue-content-loader';
import PreserveFilters from '@/components/PreserveFilters'
import DateHistogramSlider from '@/components/DateHistogramSlider'

export default {
  name: 'home',
  components: {
    Search,
    ResultList,
    ResultDetail,
    FacetFields,
    ActiveFilters,
    //AutoFilters,
    Sorting,
    SuggestedFilters,
    FacetRanges,
    //SpecialDateFilter,
    Toolbar,
    Spelling,
    Error,
    SemanticGraph,
    ListLoader,
    PreserveFilters,
    DateHistogramSlider,
    LoadingIndicator
  },
  data () {
    return {
    }
  },
  created: function () {
    if( this.$router.currentRoute.query && this.$router.currentRoute.query.q ) {
      this.$store.dispatch('fetchSearchResponse');
    } else {
      this.$store.dispatch('fetchSearchResponseByQuery', '*')
    }
  },
  computed: {
    response () {
      return (this.$store.state.response)
        ? this.$store.state.response.response : null;
    },
    searchQuery () {
      return (this.$store.state.response &&
          this.$store.state.response.context &&
          this.$store.state.response.context.processedSearchTerms )
        ? this.$store.state.response.context.processedSearchTerms : null;
    },
    expiredTrial() {
      if (this.$store.state ) {
        return this.$store.state.expiredTrial;
      }
      return false;
    },
  },
  methods: {
  },
  watch: {
    $route(to) {

      if( to.query && to.query.q ) {
        this.$store.dispatch('fetchSearchResponse');
      }
      else if( '/' === to.path ) {
        this.$store.dispatch('fetchSearchResponseByQuery', '*');
      }

    }
  }
}
</script>

<style>
</style>
